import React from 'react';

export default function Component(props) {

  const { ansDMGTextBox, question, SurveyAttributes, answersList, rowData, isRowComplete } = props;


  let rowList = []
  if (question && question.dmgModule && question.dmgModule === "SELF") {
    rowList = rowData && rowData.selfList && rowData.selfList.length > 0 ? rowData.selfList : []
  } else if (question && question.dmgModule && question.dmgModule === "CROSS") {
    rowList = rowData && rowData.crossList && rowData.crossList.length > 0 ? rowData.crossList : []
  }


  function matchAnswer(list, question, dmgValue) {
    let value = "";
    if (list && list.length > 0) {
      let getIndex = list.findIndex(prev => prev.questionId.toString() === question.id.toString());
      if (getIndex !== -1) {
        if (list && list[getIndex] && list[getIndex]["multiAnswer"] && list[getIndex]["multiAnswer"].length > 0) {
          let getIndex2 = list[getIndex]["multiAnswer"].findIndex(prev => prev.optionHead.toString() === dmgValue.toString());
          if (getIndex2 != -1) {
            value = list[getIndex]["multiAnswer"][getIndex2]["optionAns"];
          }
        }

      }
    }
    return value
  }

  let rowListV1 = [];
  if (rowList && rowList.length > 0) {
    let substringToFind = 'Self';
    let sortOrder = rowList.filter(item => item.value.includes(substringToFind));
    console.log("sortOrder---->", sortOrder);

    rowList.forEach((ele, index) => {
      if (ele.value === (sortOrder && sortOrder[0] && sortOrder[0]["value"] ? sortOrder[0]["value"] : "")) {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": 1
        })
      } else {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": index + 1000
        })
      }
    });

    rowListV1.sort((a, b) => {
      return a.index - b.index;
    });


  }

  return (
    <>
      <div className="w-full mb-4 pt-2">
        <div className="overflow-x-auto overflow-y-auto  w-full " >
          {rowListV1 && rowListV1.length > 0 ?
            <div>
              <div className='w-full space-y-4'>
                {rowListV1 && rowListV1.length > 0 ?
                  rowListV1.map((row, rowIndex) =>
                    <div className=' flex md:flex-row flex-col md:gap-6 md:items-center  w-full '>
                      <div className={'md:w-[40%] w-full md:text-right text-left ' + (isRowComplete(answersList, row.value, question) ? "text-[#212121]" : "text-red-500")}>{row.value}</div>
                      <div className='md:w-[60%] w-full '>
                        <input
                          key={rowIndex}
                          value={matchAnswer(answersList, question, row.value)}
                          onChange={(event) => ansDMGTextBox(event, question, row)}
                          className='p-2 w-full border rounded-md focus:outline-none'
                          placeholder={SurveyAttributes("WriteHereText") ? SurveyAttributes("WriteHereText") + "..." : "Write here..."} />
                      </div>
                    </div>
                  ) : null}
              </div>
            </div>
            : null}
        </div>
      </div>
    </>
  );
}